import { useMutation } from '@tanstack/react-query';
import { uploadRachelFile } from './rachelFiles.repository';
import { RachelFileOutput, UploadRachelFileVariables } from './rachelFiles.types';

export const useUploadRachelFile = () =>
  useMutation({
    mutationFn: async ({ file, signal }: UploadRachelFileVariables): Promise<RachelFileOutput> => {
      const response = await uploadRachelFile(file, signal);
      if (!response.ok || !response.data) {
        throw response;
      }
      return response.data;
    },
  });
